<template>
   <v-main>
    <div :style="{
      backgroundImage: `url(${ImgCover})`,
      height: '240px',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }"></div>
    <div v-if="hasBooking">
    <div v-if="queueSheet.queueNumber">
    <v-row justify="center" align-content="center">
      <v-col col="12" class="text-center mt-3">
        <v-chip class="mr-1 font-weight-black"
          :style="'background-color:' + (queueSheet.languageSelect === 0 ? DarkModeButton : 'rgb(103 103 103 / 18%)') + ';font-size:25px'"
          dark @click="onLanguageSelect(0)">
          <v-avatar left>
            <v-img
              src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e"></v-img>
          </v-avatar>
          TH
        </v-chip>
        <v-chip class="ml-1 font-weight-black"
          :style="'background-color:' + (queueSheet.languageSelect === 1 ? DarkModeButton : 'rgb(103 103 103 / 18%)') + ';font-size:20px'"
          dark @click="onLanguageSelect(1)">
          <v-avatar left>
            <v-img
              src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b"></v-img>
          </v-avatar>
          EN
        </v-chip>
      </v-col>
    </v-row>
    <v-row  justify="center" align-content="center" v-if="userId === 'No Line'" >
      <v-col cols="12" class="text-center">
        <v-btn color="#d91883" rounded  large @click="getBotinfo()" style="height: 56px; border: 2px solid #ffffff; " elevation="5">
            <div class="mr-3"> <v-avatar color="#ffffff" size="40">
              <v-icon color="#d91883">mdi-bell-ring</v-icon>
            </v-avatar></div>
          <div>
            <span style="color:#ffffff; letter-spacing:normal; font-weight:700">
            {{ queueSheet.languageSelect === 0 ? 'กดปุ่ม เพื่อรับการแจ้งเตือนคิวผ่าน LINE' : 'Get queue notifications via LINE.' }}</span> </div>
        </v-btn>
      </v-col>
    </v-row>
    <div class="pa-4 my-4"   :style="'background-color:' + DarkModeBackground + '; min-height: 100vh'">
      <QueueSheet  :queue="queueSheet"/>
      <QueseBooking :darkModeBackground="DarkModeBackground" :languageSelect="queueSheet.languageSelect" :bookingUse="queueBooking"/>

    </div>
  </div>
  <div v-else class="loading-container mt-5">
    <v-progress-circular
    indeterminate
    class="color-progress"
    color="#94d50b"
    :size="50"
    :width="4"
  ></v-progress-circular>
  <h6 style="color:#092C4C" class="text-center font-weight-bold mt-2"> {{ queueSheet.languageSelect === 0 ? "กำลังตรวจสอบคิว..." : "Please wait while we check your queue status..." }}</h6>
  </div>
    <v-footer padless fixed>
        <v-col
          class="text-center"
          cols="12"
        >
        <div style="color:#092C4C; font-weight: bold; font-size: 13px;">{{ queueSheet.languageSelect === 0 ? "*บริษัทฯ ขอสงวนสิทธิ์ในการข้ามคิว กรณีลูกค้าไม่แสดงช่องบริการ" : "Note: The company reserves the right to skip the queue. In the case where the customer does not display the counter" }}</div>
        </v-col>
      </v-footer>
      </div>
      <div v-else class="d-flex flex-column align-center justify-center text-center">
             <v-icon class="mt-4" large style="font-size: 60px;" color="info" size="60">mdi-alert-circle-outline</v-icon>

                <h5 class="mt-4">ไม่พบข้อมูล</h5>
                  <p>ขออภัย ไม่พบข้อมูลที่คุณกำลังค้นหา</p>
      </div>
  </v-main>
</template>

<script>
import axios from 'axios' // api
import QrcodeVue from 'qrcode.vue'
import moment from 'moment'
import QueueSheet from '../OhRich/QueueSheet.vue'
import QueseBooking from '../OhRich/QueseBooking.vue'

export default {
  components: {
    name: '',
    QrcodeVue,
    QueueSheet,
    QueseBooking
  },
  data () {
    return {
      value: '',
      profile: null,
      DarkMode: '',
      DarkModeStatus: null,
      DarkModeButton: '',
      DarkModeBackground: '#F6FFE0',
      DarkModefont: '',
      shop: [],
      LoGo: [],
      ImgCover: '',
      shopId: '',
      bookNo: this.$route.query.bookNo,
      dataLineConfig: {},
      source: '',
      checkRef: false,
      checkStatusEdit: true,
      userId: '',
      masBranchID: '',
      isLoading: false,
      queueBooking: [],
      unsubscribe: null,
      queueSheet: { shopName: '', flowNameTh: '', flowNameEn: '', dueDate: '', counter: '', previousQueue: 0, queueNumber: '', status: '', languageSelect: 0 },
      hasBooking: true
    }
  },
  created () {
    this.getFirestore()
  },
  beforeDestroy () {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  async mounted () {
    this.isLoading = true
    try {
      this.source = 'ohrich'
      this.shopId = 'Ue9f527da07ff2da05246ea3f62671493'
      this.hasBooking = !!this.$route.query.bookNo
      this.booking = this.$route.query.bookNo
      await this.getShop()
      if (this.booking) {
        await this.getDataDef()
      }
    } catch (error) {
      console.log('error', error)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    async getDataDef () {
      await this.getBookingData()
      await this.searchBooking()
      // await this.updateProcessOhrichUpdate()
    },
    async getFirestore () {
      if (this.unsubscribe) {
        this.unsubscribe()
      }
      this.firestore = this.$firebase.firestore()
      this.unsubscribe = this.firestore.collection('ProcessOhrichUpdate').doc(this.$route.query.bookNo)
        .onSnapshot(async (snapshot) => {
          console.log('firestore', snapshot.exists)

          if (!snapshot.exists) {
            await this.updateProcessOhrichNew()
          } else {
            if (snapshot.data().active === '1') {
              console.log('active [start] is updateProcessOhrichUpdate')
              await this.updateProcessOhrichUpdate()
              await this.getDataDef()
            } else {
              console.log('snapshot data -> active is 0')
            }
          }
        })
    },
    async updateProcessOhrichNew () {
      try {
        let body = {
          userName: this.$route.query.bookNo,
          masBranchID: this.masBranchID
        }
        await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/Pepsico-ProcessOhrichUseNew', body)
      } catch (error) {
        console.log('updateProcessOhrichNew error ->', error)
      }
    },
    onLanguageSelect (locale) {
      this.queueSheet.languageSelect = locale
    },
    async updateProcessOhrichUpdate () {
      const params = {
        userName: this.$route.query.bookNo,
        masBranchID: this.masBranchID
      }

      try {
        const response = await axios.post(
          'https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/Pepsico-ProcessOhrichUseNew',
          params
        )
        console.log('Process update successful:', response.data)
      } catch (error) {
        console.error('Error updating process:', error.response ? error.response.data : error.message)
      }
    },
    async searchBooking () {
      try {
        let arrDataService = []
        await axios.get(`${this.DNS_IP}/booking_view/getQueueOhrichTV?masBranchID=${this.masBranchID}`)
          .then(async response => {
            if (response.data) {
              const data = response.data
              if (data.status) {
                arrDataService = data.dataService
              } else {
                arrDataService = []
              }
            }
          })
        this.queueBooking = arrDataService
      } catch (error) {
        console.log('error', error)
      }
    },
    async checkLiffLogin (dataLineConfig) {
      console.log('dataLineConfig', dataLineConfig)
      await this.$liff
        .init({
          liffId: dataLineConfig.liffMainID
        })
        .then(async () => {
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              this.$liff.login({ redirectUri: window.location.href + '&checkLineLogin=T' })
              // this.$liff.login({ redirectUri: 'https://https://liff.line.me/' + dataLineConfig.liffMainID + '/CheckQueueStoreFrontOhrich?bookNo=BK101354421703415970135' + '&checkLineLogin=T' })
            } else {
              await this.getProfile()
            }
          }
        })
        .catch(err => {
          // this.$router.push({ name: '404' })
          console.log(err.code, err.message)
        })
      // this.$liff.init({ 'liffId': liffId }, function (data) {})
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(async function (profile) {
          _this.profile = profile
          console.log('prod', _this.profile)
          await _this.checkMemberOhrich()
        })
        .catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      console.log('dev', this.profile)
    },
    async getShop () {
      if (this.shopId) {
        await axios.get(this.DNS_IP + '/sys_shop/get?shopId=' + this.shopId).then(response => {
          let rs = response.data
          if (rs.length > 0) {
            this.shop = rs
            console.log('this.shop', this.shop)
            this.queueSheet.shopName = rs[0].shopName
            this.DarkModeBackground = rs[0].primaryColor
            this.DarkModeButton = rs[0].secondaryColor
            this.ImgCover = rs[0].shopImageCover
            this.LoGo = rs[0].shopImge
          } else {
            this.shop = null
          }
        })
      }
      console.log('this.shop', this.shop)
    },
    async getBookingPreviousQueue (dueDateDay, branchID, flowId, storeFrontQueue) {
      try {
        this.queueSheet.previousQueue = 0
        const response = await axios.get(
          `${this.DNS_IP}/booking_view/getDataBookingOhrich?shopId=${this.shopId}&dueDate=${dueDateDay}&masBranchID=${branchID}&flowId=${flowId}&storeFrontQueue=is not null&status=confirm`
        )
        const rs = response.data
        if (rs.length > 0) {
          const filteredItems = rs.filter(item => item.storeFrontQueue === storeFrontQueue)
          if (filteredItems.length > 0) {
            const findIndex = rs.findIndex(item => item.storeFrontQueue === storeFrontQueue)
            this.queueSheet.previousQueue = rs.slice(0, findIndex).length
          }
        } else {
          console.log('No data found for the given parameters')
        }
      } catch (error) {
        console.error('Error fetching booking queue:', error)
      }
    },
    async getBookingData () {
      try {
        const response = await axios.get(
          `${this.DNS_IP}/booking_view/getDataBookingOhrich?shopId=${this.shopId}&bookNo=${this.bookNo}`
        )
        if (response.data && response.data.length > 0) {
          const [booking] = response.data
          console.log('getBookingData', booking)
          this.queueSheet = {
            ...this.queueSheet,
            flowNameEn: booking.flowNameEn || '',
            flowNameTh: booking.flowName || '',
            dueDate: this.momenDate_2(booking.dueDate),
            queueNumber: booking.storeFrontQueue || '',
            counter: booking.servicePoint || '',
            status: booking.statusBt || ''
          }
          this.userId = booking.userId || 'No Line'
          this.masBranchID = booking.masBranchID
          if (booking.statusBt === 'confirm') {
            await this.getBookingPreviousQueue(
              booking.dueDateDay,
              booking.masBranchID,
              booking.flowId,
              booking.storeFrontQueue
            )
          }
        } else {
          console.log('No booking data found')
        }
      } catch (error) {
        console.error('Error fetching booking data:', error)
      }
    },
    async getBotinfo () {
      if (this.source === 'ohrich') {
        this.dataLineConfig = await this.getDataLineConfig(this.shopId)
        window.location.href = 'https://liff.line.me/' + this.dataLineConfig.liffUpdateNotiLinaOA + '?bookNo=' + this.$route.query.bookNo
        // this.dataLineConfig = await this.getDataLineConfig(this.shopId)
        // await this.checkLiffLogin(this.dataLineConfig)
      }
    },
    async checkMemberOhrich () {
      await this.saveUserId()
      await axios.get(this.DNS_IP + '/member/get?shopId=' + this.shopId + '&liffUserId=' + this.profile.userId).then(async result => {
        var lineUserIds = ''
        var liffUserIds = ''
        if (result.data.status === false) {
          await this.onSubmit()
        } else {
          lineUserIds = result.data[0].lineUserId || ''
          liffUserIds = result.data[0].liffUserId || ''
          if (lineUserIds === '' && liffUserIds !== '') {
            await this.onUpdate(result.data[0].memberId)
          }
        }
        let dttt = {
          checkGetQueue: 'False',
          firstSend: 'True'
        }
        await axios
          .post(this.DNS_IP + '/Booking/pushMsgQueueOhrich/' + this.$route.query.bookNo, dttt)
          .then(async response => { }).catch(error => {
            console.log('error function pushMsgQueueOhrich : ', error)
          }).catch(error => {
            console.log('error function pushMsgQueueOhrich : ', error)
          })
      }).catch(error => {
        console.log('error function member get : ', error)
      })
    },
    async saveUserId () {
      let userId = {
        'userId': this.profile.userId
      }
      await axios.post(this.DNS_IP + '/Booking/edit/' + this.$route.query.bookNo, userId).then(async response => {
        console.log('response', response)
      }).catch(error => {
        console.log('error function saveUserId : ', error)
      })
    },
    async onSubmit () {
      // var idMember = 'Link_' + Date.now()
      var idMember = moment().valueOf()
      const params = {
        name: this.profile.displayName,
        picture: this.profile.pictureUrl,
        liffUserId: this.profile.userId,
        lineUserId: this.profile.userId,
        shopId: this.shopId,
        memberId: idMember,
        CREATE_USER: this.profile.userId,
        LAST_USER: this.profile.userId
      }
      const result = await this.callBeTaskAPIActivity('post', `/member/add`, params)
      console.log('result', result.status)
    },
    async onUpdate (idMember) {
      // "https://api-belinked.betaskthai.com/member/editWebhook/" + request.body.events[0].message.text.split(" ")[2]
      // window.location.replace(`https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`)
      // window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`
      const params = {
        lineUserId: this.profile.userId,
        liffUserId: this.profile.userId,
        LAST_USER: this.profile.userId
      }
      const result = await this.callBeTaskAPIActivity('post', '/member/editWebhook/' + idMember, params)
      console.log('result', result.status)
    },
    async callBeTaskAPIActivity (method, url, params) {
      let result = null
      //   const token = this.$liff.getAccessToken() || '1234567890'
      await axios({
        method: method,
        // headers: {
        //   accessToken: token,
        //   lineUserId: this.profile.userId,
        //   activityId: this.formUpdate.activityId
        // },
        url: this.DNS_IP + url,
        data: params
      }).then((response) => {
        result = response.data
      }).catch((error) => {
        console.log(error)
        result = null
      })
      return result
    }
  }
}
</script>

<style scoped>
.main {
  background-color: #ffffff;
  height: 100%;
}

.content {
  overflow-y: scroll;
  white-space: normal;
}

.a {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  max-height: 350px;
}
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.color-progress {
  color: #0000; /* กำหนดสีแบบกำหนดเอง */
}
</style>



// WEBPACK FOOTER //
// src/components/Booking/CheckQueueStoreFrontOhRich.vue